import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNexOs } from "@/lib/nexOs";

export const PERIODS = [["week", "Week"], ["month", "Month"], ["all", "All time"]];

/** Week | Month | All time — the selected one is highlighted. */
export default function PeriodToggle({ value, onChange, testid, busy }) {
  return (
    <div role="tablist" data-testid={testid} aria-busy={busy || undefined} className="inline-flex rounded-sm border border-white/15 overflow-hidden">
      {PERIODS.map(([k, l]) => (
        <button key={k} type="button" role="tab" aria-selected={value === k} onClick={() => value !== k && onChange(k)} data-testid={`${testid}-${k}`}
          className={`px-3 py-1.5 font-mono text-[0.6rem] uppercase tracking-[0.16em] transition-colors ${value === k ? "bg-nex-gold/20 text-nex-gold" : "text-nex-chrome hover:text-nex-silver hover:bg-white/5"}`}>{l}</button>))}
    </div>
  );
}

const arrow = "p-1.5 rounded-sm border border-white/15 text-nex-chrome hover:text-nex-gold disabled:opacity-30 disabled:hover:text-nex-chrome transition-colors";

/** The one shared desk period (Pulse + Money row): view toggle, ◀ label ▶ and "Back to current". `rg` is the range the server sent back. */
export function DeskPeriodBar({ rg, busy, testid }) {
  const { desk, setDesk, switching } = useNexOs();
  const view = desk.view;
  const unit = view === "week" ? "week" : "month";
  const same = rg && rg.period === view;
  const loading = busy || switching || !same;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-testid={testid}>
      <PeriodToggle value={view} onChange={(k) => setDesk({ view: k, at: (same && rg.switch?.[k]) || null })} testid={`${testid}-toggle`} busy={loading} />
      <div className="inline-flex items-center gap-1.5 whitespace-nowrap">
        {view !== "all" && <button type="button" onClick={() => setDesk({ view, at: rg.prev })} disabled={loading || !rg.prev} aria-label={`Previous ${unit}`} data-testid={`${testid}-prev`} className={arrow}><ChevronLeft className="w-3.5 h-3.5" /></button>}
        <span className="font-mono text-[0.65rem] text-nex-chrome tracking-[0.14em] uppercase min-w-[11rem] text-center" data-testid={`${testid}-range`}>
          {loading && !same ? "Loading…" : rg ? (rg.period === "all" ? "All time · everything in the ledger" : rg.label) : ""}</span>
        {view !== "all" && <button type="button" onClick={() => setDesk({ view, at: rg.next })} disabled={loading || !rg.next} aria-label={`Next ${unit}`} data-testid={`${testid}-next`} className={arrow}><ChevronRight className="w-3.5 h-3.5" /></button>}
      </div>
      {same && !rg.current && <button type="button" onClick={() => setDesk({ view, at: null })} data-testid={`${testid}-current`} className="font-mono text-[0.6rem] tracking-[0.16em] uppercase text-nex-gold hover:underline">Back to current</button>}
    </div>
  );
}
